import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {IonicModule} from '@ionic/angular';
import {RouterModule} from '@angular/router';
import {FabricCardComponent} from './fabric-card/fabric-card.component';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        IonicModule.forRoot()
    ],
    declarations: [FabricCardComponent],
    exports: [FabricCardComponent]
})
export class FabricsModule {
}
